<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item title-bread md-size-100 title-prices-section">
        <div class="md-group pull-left title">
          AgBi - Precios
        </div>
        <label-az-group />
      </div>
      <div class="md-layout-item md-size-100" style="margin-top:60px; text-align: center;">
        <iframe title="Tablero Evolucion de Precios" id="iframe-precios"
          src="https://app.powerbi.com/view?r=eyJrIjoiYjYyOGRiNDctNjYxYS00ZjAzLTllOTktNDA4NWQ1ZjE0NjhmIiwidCI6ImY4MzNmNjI4LTA4MGEtNDJkOS1hOTVmLWU5ZTFjM2Y0MWNiZCJ9&language=es"
          width="1000" height="622" frameborder="0" allowfullscreen="allowfullscreen"></iframe>
        <p style="text-align: center; width: 100%; font-size: 1rem; font-style: italic;">Recomendamos visualizar los
          tableros en versión de computadora de escritorio.</p>

      </div>
      <modal @close="closeModal" v-if="displayModal" class="advertising-modal">
        <template slot="body">
          <img :src="adv[6]" style="max-height: 500px">
        </template>
        <template slot="footer">
          <md-button class="md-danger md-simple" @click="closeModal">Cerrar</md-button>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Price from '@/components/Graphs/Price'
import Modal from '@/components/Modal'
import InfoIcon from "../components/InfoIcon";
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiSprout, mdiCorn, mdiBarley, mdiSpa, mdiFlowerOutline } from '@mdi/js'
import LabelAzGroup from '@/components/LabelAzGroup.vue'

export default {
  components: { InfoIcon, Price, Modal, SvgIcon, LabelAzGroup },
  data() {
    return {
      ready: false,
      optionSelected: 'Granos',
      typeSelected: '',
      data: [],
      displayModal: false,
      headers: [],
      unit: '',
      icons: {
        trigo: mdiBarley,
        maiz: mdiCorn,
        soja: mdiSprout,
        cebada: mdiSpa,
        girasol: mdiFlowerOutline,
      }
    }
  },
  computed: {
    ...mapState(['grains', 'supplies', 'prices', 'info', 'adv']),
    dropDownType() {
      return (this.optionSelected == 'Granos') ? this.grains : this.supplies;
    }
  },
  watch: {
    typeSelected() {
      this.generateData();
    }
  },
  methods: {
    changeSelectedOption(option) {
      this.optionSelected = option;
      this.typeSelected = (this.optionSelected == 'Granos') ? this.grains[0] : this.supplies[0]
    },
    changeSelectedType(type) {
      this.typeSelected = type;
    },
    getPriceRow() {
      let result = [];

      for (let key in this.prices)
        if (this.prices[key][0] == this.optionSelected && this.prices[key][1] == this.typeSelected)
          result = this.prices[key].slice(2);

      return result;

    },
    generateData() {
      this.ready = false;
      this.data = this.getPriceRow();
      this.$nextTick(function () {
        this.ready = true
      })
    },
    closeModal() {
      this.displayModal = false;
    },
    cropKey(crop) {
      if (!crop) return '';

      // Pasamos a string, minúsculas, sin espacios al inicio/fin
      let key = crop.toString().toLowerCase().trim();

      // Eliminamos acentos/diacríticos para que "maíz" matchee con "maiz"
      key = key.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      // Tomamos solo la primera "palabra" antes de guiones, espacios u otros separadores:
      // "trigo-soja" => "trigo", "cebada soja" => "cebada"
      const parts = key.split(/[^a-z]/).filter(Boolean);
      if (parts.length > 0) {
        key = parts[0];
      }

      return key;
    },
  },

  mounted() {
    this.typeSelected = this.grains[0];
    this.headers = this.prices[0].slice(3);

    //setTimeout(() => { this.displayModal = true; }, 3000);
    this.generateData();
  }
}
</script>
<style>
  .title-prices-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
.crop-icon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
  vertical-align: middle;
}

#iframe-precios {
  border: none;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 8px;
  margin-top: 1rem;
  margin-bottom: 1rem;
  min-height: 622px;
}
@media screen and (max-width: 720px) {
  #iframe-precios {
    min-height: 250px;
  }
}
</style>
